import type { AppModule } from '../registry';
import { IconBusiness360 } from '../../components/icons';
import { OverviewView } from './OverviewView';

// Business 360 app-module. Placeholder today (B360 is internal-only — no tenant-scoped product
// surface yet); the registered module gives a tenant granted business360 an intentional tab.
// Replace OverviewView with the real research/lead-list views when B360 ships its tenant API.
export const business360_module: AppModule = {
  app_code: 'business360',
  label: 'Business 360',
  blurb: 'Verified prospect research and lead lists — coming soon to your workspace.',
  icon: <IconBusiness360 />,
  accent: '#7c3aed',
  nav: [{ path: 'overview', label: 'Overview', element: <OverviewView /> }],
};
